<div id="map" class="map shadow-3"></div>
<button class="lll" (click)="setCurrentPosition()">CURRENT</button>
<div id="popup" class="ol-popup shadow-6">
    <div class="mapsPopUpHeader"></div>
    <div class="mapsPopUpContent">
        <div class="singleExperienceCardMap" *ngFor="let exp of currentSelectedExperiences">
            <app-experience-card [experience]="exp" (click)="onClick(exp)"></app-experience-card>
        </div>
    </div>
    <div class="mapsPopUpFooter"></div>
</div>